import React, {useEffect} from 'react'
import { connect } from 'react-redux';
import { guestDetails, guestJourneyNotification } from '../../../action/homeAction';
import { wipeGuestData } from '../../../JS/wipeGuestData';
import { setQueuedCheckInSuccess } from '../../../action/action';
import { INROOMTAB } from '../../../config/constant';

function DmqEventHandler(props) {

    useEffect(() => {

        document.addEventListener("GUEST_CHECK_IN", () => {
            console.log("GUEST_CHECK_IN event fired");
            wipeGuestData({inRoomTab: INROOMTAB, eventName: "GUEST_CHECK_IN"})
            // call register api and refresh.
        })

        document.addEventListener("QUEUED_GUEST_CHECKED_IN", () => {
            console.log("QUEUED_GUEST_CHECKED_IN");
            if(!localStorage.getItem("GuestIsCheckin")) props.setQueuedCheckInSuccess(true)
            // render popup
        })

        document.addEventListener("DEVICE_REGISTRATION", () => {
            console.log("DEVICE_REGISTRATION")
            localStorage.setItem("GuestJourneySessionToken", "");
            document.location.reload();
        })

        document.addEventListener("GUEST_INFO_UPDATE", () => {
            console.log("GUEST_INFO_UPDATE event fired");
            let token = localStorage.getItem("GuestJourneySessionToken")
            let guestToken = localStorage.getItem('guestToken')
            // calling guest details api
            props.guestDetails(token,
                () => wipeGuestData({inRoomTab: INROOMTAB, eventName: "GUEST_INFO_UPDATE"}),guestToken);
        })

        document.addEventListener("MESSAGE_PENDING", () => {
            console.log("MESSAGE_PENDING event fired");
            let token = localStorage.getItem("GuestJourneySessionToken")
            // calling text message api
            props.guestJourneyNotification(token);
        })

        document.addEventListener("DEVICE_DATA_REFRESH", () => {
            console.log("DEVICE_DATA_REFRESH event fired");
            let token = localStorage.getItem("GuestJourneySessionToken")
            let guestToken = localStorage.getItem('guestToken')
            // calling deviceConfig, textMessage, guest detail apis
            props.callLayoutAPI(); // deviceConfig

            props.guestJourneyNotification(token); // textMessage

            props.guestDetails(token, // guest details
                () => wipeGuestData({inRoomTab: INROOMTAB, eventName: "GUEST_INFO_UPDATE"}),guestToken);
        })

        document.addEventListener("DEVICE_WIPE", () => {
            console.log("DEVICE_WIPE event fired");
            wipeGuestData({inRoomTab: INROOMTAB, eventName: "DEVICE_WIPE"})
            // call register with location id
        })

        document.addEventListener("GUEST_CHECK_OUT", () => {
            console.log("GUEST_CHECK_OUT event fired");
            // call location id
            wipeGuestData({inRoomTab: INROOMTAB, eventName: "GUEST_CHECK_OUT"})
        })
    
    }, [])
    

  return <></>
}

const mapStateToProps = (state, props) => {
    return {}
}

export default connect(mapStateToProps, {guestDetails, guestJourneyNotification, setQueuedCheckInSuccess})(DmqEventHandler);

// What above events do? see below.

// GUEST_INFO_UPDATE : This is the Guest Data has been updated notification from CMS (it is how Device would know checkIn has occurred)
// DEVICE_WIPE : Wipe guest data from device like logins done to NetFlix, Youtube etc native apps, Browser search history etc (This is how it  is for TVs, needs to be redefined for inRoom Apps)
// GUEST_CHECK_IN : This is the CheckIn notification from CMS (it is how Device would know checkIn has occurred)
// GUEST_CHECK_OUT : This is the CheckOut notification from CMS (it is how Device would know checkIn has occurred)
// MESSAGE_PENDING : Need to refresh Text Messages when this message is received
// DEVICE_DATA_REFRESH (NEW) : This is to forceApp to fetch following things from CMS Again : Layout, Text Messages, Guest Info, channelData